export const selectors = {
  spacer: "SpacerSection",
};
